import React from 'react';
import PropTypes from 'prop-types';

// COMPONENTS
import { TagChip } from 'components';

function ProfileSpecialities({ specialities }) {
  return specialities.length === 0
    ? <p className="ProfileSpecialities ProfileSpecialities--empty">Sem informações</p>
    : (
      <ul className='ProfileSpecialities'>
        {
          specialities.map((speciality, index) => {
            return (
              <li className="ProfileSpecialities__item" key={index}>
                <TagChip label={speciality} />
              </li>
            );
          })
        }
      </ul>
    )
}

ProfileSpecialities.propTypes = { specialities: PropTypes.any };

export default ProfileSpecialities;